/**
 * Validate UPC length according to standard formats
 * @param {string} upc - The UPC code to validate
 * @returns {{ valid: boolean, error: string | null }} Validation result
 */
export function validateUpcLength(upc) {
  // Empty/null values are allowed (optional field)
  if (!upc || upc.trim() === '') {
    return { valid: true, error: null };
  }

  const trimmedUpc = upc.trim();
  
  // Remove any non-digit characters for validation
  const digitsOnly = trimmedUpc.replace(/\D/g, '');
  
  // Check if the UPC contains only digits
  if (digitsOnly !== trimmedUpc) {
    return { 
      valid: false, 
      error: 'UPC must contain only digits' 
    };
  }

  const length = digitsOnly.length;
  
  // Valid UPC formats: UPC-A (12), EAN-13 (13), GTIN-14 (14)
  const validLengths = [12, 13, 14];
  
  if (validLengths.includes(length)) {
    return { valid: true, error: null };
  }

  return { 
    valid: false, 
    error: `UPC must be 12, 13, or 14 digits (found: ${length} digits)` 
  };
}
